module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_11.a4fa2498.png";